import { IconButton, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, TextField, useTheme, Box, Typography, FormControl, Divider, Button, alpha } from "@mui/material";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomPagination from "../../../components/table/CustomPagination";
import { useEffect, useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import Close from '@mui/icons-material/Close';
import * as XLSX from "xlsx";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { tokens } from "../../../theme/theme";
import GlobalConfig from "../../../config/date/GlobalConfig";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

// API function to fetch WIP Ream details
const getReamPunchingDetails = async (payload) => {
  try {
    const endpoint = API_ENDPOINTS.PROD_MANAGEMENT_REPORT_GET_REAMPUNCHING_WIP_REAMS;
    return await callApi(endpoint, "POST", { "Content-Type": "application/json" }, payload);
  } catch (error) {
    console.error("Error fetching WIP Ream details:", error);
    throw error;
  }
};

const ReportReamPunchingWIPReamList = ({ handleBackSheeterMachineEntry, mode }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Table State
  const [wipReamDetails, setWipReamDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // Filters
  const [filterFromDate, setFilterFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, "day"));
  const [filterToDate, setFilterToDate] = useState(dayjs());
  const [filters, setFilters] = useState({});
const dateKeys = ["created_date_time", "created_date", "prod_date"];
  // Column and filter keys
  // const reamColumns = [
  //   "ID REAM", "ID REAM HDR", "SHEETS IN REAMS", "REAM WEIGHT", "L REAM STATUS", 
  //   "CREATED BY", "CREATED DATE", "STATUS", "REAM NUMBER", "COMPANY ID", 
  //   "PLANT ID", "ID BUNDLE", "ID REAM PALLET", "CR NUMBER", "CREATED DATE TIME", 
  //   "REPULP QTY", "GRADE", "WINDER REMARKS"
  // ];

  // const reamFilterKeys = [
  //   "id_ream", "id_ream_hdr", "sheets_in_reams", "ream_weight", "l_ream_status",
  //   "created_by", "created_date", "status", "ream_number", "company_id",
  //   "plant_id", "id_bundle", "id_ream_pallet", "cr_number", "created_date_time",
  //   "repulp_qty", "grade", "winder_remarks"
  // ];
const reamColumns = [
  "JOB NO",
  "PROD. DATE",
  "SHIFT_CODE",
  "REEL NO",
  "TEMP PALLET NO",
  "REAM NUMBER",
  "QUALITY",
  "GRADE",
  "GSM",
  "SHEETS IN REAMS",
  "REAM WEIGHT",
  "ORDER NO",
  "WIDTH",
  "LENGTH",
  "REMARKS"
];

const reamFilterKeys = [
  "job_no",
  "prod_date",
  "shift_code",
  "reel_no",
  "temp_pallet_no",
  "ream_number",
  "quality",
  "grade",
  "gsm",
  "sheets_in_reams",
  "ream_weight",
  "order_no",
  "width",
  "length",
  "remarks"
];

  // Load Data with date range
  const loadDataWithDate = async (from, to) => {
    setLoading(true);
    
    try {
      const p_companyid = localStorage.getItem("companyid");
      const fromDate = (from.year() > 1) ? dayjs(from).format("YYYY-MM-DD") : null;
      const toDate = (to.year() > 1) ? dayjs(to).format("YYYY-MM-DD") : null;
      const payload = {
       p_companyid: p_companyid,
     p_plantid: 1,
     p_frommodate: fromDate,
     p_tomodate: toDate,
     p_mode: 0,
      };
      const data = await getReamPunchingDetails(payload);
      setWipReamDetails(data);
    } catch (error) {
      setWipReamDetails([]);
    } finally {
      setLoading(false);
    }
  };

  // Load Data without date filter
  const loadDataWithoutDate = async () => {
    setLoading(true);
    try {
      const p_companyid = localStorage.getItem("companyid");
      const payload = {
        p_companyid: p_companyid,
        p_plantid: 1,
        p_mode: 0
      };
      const data = await getReamPunchingDetails(payload);
      setWipReamDetails(data);
    } catch (error) {
      setWipReamDetails([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dayjs(filterFromDate).isValid() && dayjs(filterToDate).isValid()) {
      loadDataWithDate(filterFromDate, filterToDate);
    }
  }, [filterFromDate, filterToDate]);

  const handleFilterChange = (e, column) => {
    setFilters({ ...filters, [column]: e.target.value });
  };

  const filteredData = wipReamDetails.filter((row) => {
    return Object.keys(filters).every((key) => {
      if (!filters[key]) return true;
      return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    });
  });

  const pageCount = Math.ceil(filteredData.length / recordsPerPage);
  const currentRecords = filteredData.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleExportToExcel = () => {
    const formattedData = filteredData.map((row) => {
      const obj = {};
      reamColumns.forEach((col, index) => {
        obj[col] = row[reamFilterKeys[index]] ?? "";
        if (reamFilterKeys[index] === "created_date_time" || reamFilterKeys[index] === "created_date") {
          obj[col] = row[reamFilterKeys[index]] ? dayjs(row[reamFilterKeys[index]]).format("DD-MMM-YYYY") : "";
        }
      });
      return obj;
    });
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "WIP REAMS DETAILS");
    XLSX.writeFile(workbook, "WIP REAMS DETAILS.xlsx");
  };

  return (
    <Box sx={{ backgroundColor: theme.palette.background.default, minHeight: "100vh", p: 2 }}>
      <Divider />
      <Box marginRight="auto" marginLeft={1}>
        <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold">
          WIP Reams List
        </Typography>
      </Box>

      {/* Date Filters & Actions */}
      <Grid container padding="5px 0" alignItems="center" sx={{ justifyContent: "flex-end" }}>
        <Grid item xs={2} sm={3} md={1.5} lg={1.5}>
          <FormControl fullWidth size="small">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={dayjs(filterFromDate)}
                onChange={(date) => setFilterFromDate(dayjs(date))}
                format="DD-MMM-YYYY"
                renderInput={(props) => <TextField {...props} variant="standard" size="small" />}
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>
        <Grid item mt="2px" ml="10px" mr="10px"><Typography fontWeight="bold">-</Typography></Grid>
        <Grid item xs={2} sm={3} md={1.5} lg={1.5}>
          <FormControl fullWidth size="small">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={dayjs(filterToDate)}
                onChange={(date) => setFilterToDate(dayjs(date))}
                format="DD-MMM-YYYY"
                renderInput={(props) => <TextField {...props} variant="standard" size="small" />}
              />
            </LocalizationProvider>
          </FormControl>
        </Grid>
        <Grid item ml={1}>
          <Button size="small" variant="contained" color="secondary" onClick={loadDataWithoutDate}>
            Fetch Data Without Date Range
          </Button>
        </Grid>
        <Grid item ml={1}>
          <IconButton onClick={handleExportToExcel}><DownloadIcon /></IconButton>
        </Grid>
        {mode === 0 && (
          <Grid item ml={1}>
            <IconButton onClick={handleBackSheeterMachineEntry}><Close style={{ color: "#2196F3" }} /></IconButton>
          </Grid>
        )}
      </Grid>

      {/* Table */}
      <Divider />
      <CustomTableContainer colors={colors}>
        <TableContainer sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {loading ? (
            <SkeletonTableLoader rows={10} columns={reamColumns.length} />
          ) : (
            <Table size="small">
              <TableHead sx={{ backgroundColor: alpha(theme.palette.primary.main, 0.1) }}>
                <TableRow>
                  {reamColumns.map((col) => (
                    <TableCell key={col} sx={{ textAlign: "center" }}>{col}</TableCell>
                  ))}
                </TableRow>
                {/* Filter Row */}
                <TableRow>
                  {reamFilterKeys.map((col) => (
                    <TableCell key={col} sx={{ padding: "4px" }}>
                      <TextField
                        variant="standard"
                        value={filters[col] || ''}
                        onChange={(e) => handleFilterChange(e, col)}
                        placeholder="Filter"
                        fullWidth
                        InputProps={{ disableUnderline: true }}
                        sx={{ fontSize: '0.75rem', borderRadius: 1, px: 1 }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentRecords.map((row, index) => (
                  <TableRow key={index} sx={{
                    backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04)
                  }}>
                    {/* {reamFilterKeys.map((key) => (
                      <TableCell key={key} sx={{ textAlign: "center" }}>
                        {key === "created_date_time" || key === "created_date" 
                          ? row[key] ? dayjs(row[key]).format("DD-MMM-YYYY") : ""
                          : row[key]}
                      </TableCell>
                    ))} */}
                    

{reamFilterKeys.map((key) => (
  <TableCell key={key} sx={{ textAlign: "center" }}>
    {dateKeys.includes(key)
      ? row[key]
        ? dayjs(row[key]).format("DD-MMM-YYYY")
        : ""
      : row[key]}
  </TableCell>
))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
          <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
        </TableContainer>
      </CustomTableContainer>
    </Box>
  );
};

export default ReportReamPunchingWIPReamList;
